import ConfirmModalV2 from '../ConfirmModalV2'
import { ReactComponent as SignalStrength } from '../../assets/icons/signal-strength.svg'
import { ReactComponent as SignalStrengthMobile } from '../../assets/icons/signal-strength.svg'
import useGetIsMobileScreen from '../../hooks/useGetIsMobileScreen'

const ConnectionRequiredModal = ({ onButtonClick }) => {
  const isMobileViewPort = useGetIsMobileScreen()

  return (
    <ConfirmModalV2
      headerText={''}
      icon={isMobileViewPort ? <SignalStrengthMobile /> : <SignalStrength />}
      onButtonTwoClick={onButtonClick}
      subtext={'Sorry, internet connection required. Please try again once the connection is restored'}
      singleButtonOnly={true}
      buttonTwoText={'OKAY'}
    />
  )
}

export default ConnectionRequiredModal
